import React from "react";
import { Box, Typography } from "@mui/material";
import useIsMobile from "./Hook/useIsMobile.js";
import PortfolioMobileView from "./pages/Portfolio/PortfolioMobileView.js";
import PortfolioPage from "./pages/Portfolio/PortfolioPage.js";
import ProfileMobileView from "./pages/Profile/ProfileMobileView.js";
import ProfileDetailsPage from "./pages/Profile/ProfileDetailsPage.js";


const ResponsiveProfileComponent = () => {
  const isMobile = useIsMobile();

  return isMobile ? <ProfileMobileView/> : <ProfileDetailsPage/>;
};

export default ResponsiveProfileComponent;
